/**
 * Route wrapper for the cadastro.
 *
 * Creation and editing share this shape and the same form: an edit is the same ten texts with a
 * key already decided. Being a route rather than a modal is what lets the header name it and the
 * browser's back button behave.
 *
 * @module Pages/BUs/OptInFeatures
 */

import { UTLoading } from '@group-link-one/gl-ui/utilities';
import type { JSX } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { OptInFeatureForm } from './Components/OptInFeatureForm/OptInFeatureForm';
import { useOptInFeature } from './Hooks/useOptInFeature';
import { MainContent } from '@/Templates/Main/MainContent/MainContent';

export const OptInFeatureFormPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { featureId } = useParams<{ featureId: string }>();

  const { data: feature, isLoading } = useOptInFeature(featureId);

  const backToList = () => {
    navigate('/opt-in-features');
  };

  // The form seeds from the feature, so it must not mount before it arrives.
  if (featureId && isLoading) {
    return (
      <MainContent
        id='opt-in-feature-form-main'
        styling={{ noBackgroundColor: true, noBorder: true }}
      >
        <UTLoading type='dots' />
      </MainContent>
    );
  }

  return <OptInFeatureForm feature={feature} onDone={backToList} />;
};
